import React, { Component } from "react"
import { Input, InputGroup } from "core/deprecated-inputs"

const remove = (str, character) => str && str.replace(character, "")
const prepend = (str, character) => str && "".concat(character, str)

export class ColorPickerInputGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: remove(props.value, "#"),
      focused: false
    }
  }

  UNSAFE_componentWillReceiveProps({ value }) {
    if (!this.state.focused) {
      this.setState({ value: remove(value, "#") })
    }
  }

  handleChange = event => {
    const value = event.target.value.replace("#", "")
    const color = { hex: prepend(value, "#"), source: "hex" }
    this.setState({ value })
    this.props.onChange(color)
  }

  handleFocus = () => {
    this.setState({ focused: true })
  }

  handleBlur = () => {
    this.setState({ focused: false })
  }

  render() {
    return (
      <InputGroup className="flex-auto" prepend="#" size="sm">
        <Input
          name="hex"
          size="sm"
          value={this.state.value}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
        />
      </InputGroup>
    )
  }
}
